import { DataService } from 'src/app/services/data.service';
import { BreadCrumb } from './../../../../interfaces/main';
import { UserType, Teacher, Student } from './../../../../interfaces/user';
import { AuthService } from './../../../../services/auth.service';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  form: FormGroup;
  user: Student | Teacher;

  isLoading = false;

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'My Account',
    url: ['/profile']
  }]

  constructor(
    private fb: FormBuilder,
    private data: DataService,
    private toastr: ToastrService,
    private auth: AuthService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.user = await this.auth.getUser();

    this.breadcrumbs.push({
      link: this.user.name,
      url: ['/profile']
    })
    this.breadcrumbs.push({
      link: 'Edit'
    })

    const form: any = {
      name: new FormControl(this.user.name, [Validators.required]),
      phone: new FormControl(this.user.phone, [Validators.required]),
      facebook: new FormControl(this.user.facebook || ''),
      wechat: new FormControl(this.user.wechat || '')
    }

    if(this.user.type === UserType.Teacher){
      form.introduction = new FormControl((<Teacher>this.user).introduction, [Validators.required]);
    }

    this.form = this.fb.group(form);
  }

  async submit(){
    try{
      this.isLoading = true;

      if(this.form.invalid){
        throw Error('Form is invalid.');
      }

      this.data.updateProfile(this.form.value).subscribe((res) => {
        if(res){
          this.router.navigate(['/profile']);
        }
      })
    }catch({message}){
      this.toastr.error(message);
    }finally{
      this.isLoading = false;
    }
  }
}
